<template>
  <div>
    <div v-if="+project.projectstatus === 10 || +project.projectstatus === 20">
      <vxe-button @click="save" :loading="btnLoading" v-if="expertList.length === 0">保存</vxe-button>
      <vxe-button @click="checkScore" v-if="expertList.length === 0" :loading="btnLoading">检查分值</vxe-button>
      <span style="color: red;font-size:14px;padding-left: 10px">{{alertmsg}}</span>
    </div>
    <div class="split-line"  v-if="expertList.length === 0"></div>
    <div class="main">
      <el-form :model="pg" ref="ruleForm" label-position="right" class="mainfrom from_input">
        <div>
          <el-form-item label="总分计算方式">
            <div v-if="+project.projectstatus === 10 || +project.projectstatus === 20">
              绝对值
            <!-- <el-radio v-model="pg.projectpgstotalrule" label="2">绝对值</el-radio> -->
            <!-- <el-radio v-model="pg.projectpgstotalrule" label="1">百分比</el-radio> -->
            </div>
            <div v-else class="from-value">{{+pg.projectpgstotalrule === 2 ? '绝对值' : '百分比'}}</div>
          </el-form-item>
          <div>
          <el-form-item :label="+pg.projectpgstotalrule === 1 ? '价格权重' : '价格分'" prop="pricescore"  int :gt="0" :lte="100">
            <div v-if="(+project.projectstatus === 10 || +project.projectstatus === 20) && expertList.length === 0">
              <el-input v-model="pg.pricescore"></el-input>
            </div>
            <div v-else class="from-value">{{pg.pricescore}}</div>
          </el-form-item>
          <el-form-item :label="+pg.projectpgstotalrule === 1 ? '商务权重' : '评审分'" prop="commercescore" int :gt="0" :lte="100">
            <div v-if="(+project.projectstatus === 10 || +project.projectstatus === 20) && expertList.length === 0">
            <el-input v-model="pg.commercescore"></el-input>
            </div>
            <div v-else class="from-value">{{pg.commercescore}}</div>
          </el-form-item>
          <el-form-item label="履约分" v-if="+project.projectdoneflg === 5">
            <div v-if="(+project.projectstatus === 10 || +project.projectstatus === 20) && expertList.length === 0">
              <el-input v-model="project.projectperformancescore" disabled></el-input>
            </div>
            <div v-else class="from-value">{{project.projectperformancescore}}</div>
          </el-form-item>
          <!-- <el-form-item :label="+pg.projectpgstotalrule === 1 ? '技术权重' : '技术分'" prop="pgstechnologyscore" int :gt="0" :lte="100">
            <div v-if="+project.projectstatus === 10">
            <el-input v-model="pg.pgstechnologyscore"></el-input>
            </div>
            <div v-else class="from-value">{{pg.pgstechnologyscore}}</div>
          </el-form-item> -->
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  export default {
    name: "projectSetTotalScoringFrom",
    mixins: [common],
    props: {
      projectid: {},
      activeName: {}
    },
    data () {
      return {
        project: {},
        pg: {
          projectpgstotalrule: 2,
          pricescore: '',
          commercescore: ''
        },
        loading:false,
        btnLoading:false,
        alertmsg: '',
        list: [],
        expertList: []
      }
    },
    async created () {
      await this.getExpert()
      await this.getPgParentList()
    },
    activated () {
      this.getExpert()
      // this.getModel()
      this.getPgParentList()
    },
    watch: {
      async activeName () {
        await this.getExpert()
        if(this.activeName === 'pfxm') {
          await this.getExpert()
          // await this.getModel()
          await this.getPgParentList()
         
        }
      }
    },
    filters: {},
    components: {},
    computed: {
    },
    deactivated () {
      // this.$destroy()
    },
    methods: {
      async getExpert () {
        this.expertList = await request({
          url: '/xmgl/project/getPexpertList',
          method: "get",
          params: {projectid: this.projectid}
        })
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: '/xmgl/project/findProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res
      },
      validateratio (rule, val, callback) {
        if (this.alreadyTotal > 100) {
          if (+this.pg.projectpgstotalrule === 1) {
            callback(Error('百分比合计不能大于100'))
          } else {
            callback(Error('绝对值合计不能大于100'))
          }
          return
        } else if (this.alreadyTotal < 100) {
          if (+this.pg.projectpgstotalrule === 1) {
            callback(Error('百分比合计不能小于100'))
          } else {
            callback(Error('绝对值合计不能小于100'))
          }
          return
        } else {
          callback()
        }
      },
      save () {
        // this.btnLoading = true;
        let sum = Number(this.pg.pricescore) + Number(this.pg.commercescore)
        if (+this.project.projectdoneflg === 5) {
          sum += Number(this.project.projectperformancescore)
        }
        if(sum != 100){
          this.$message.warning('总分应该等于100！')
          return
        }
        this.submitForm('ruleForm').then(async() => {

          let list = [{
            pgid: this.list.length ? this.list[0].pgid : '',
            pgprojectid: this.projectid,
            pgparentid: 0,
            pgseq: 1,
            pgname: '价格',
            pgflg: 1,
            pgratio: this.pg.pricescore,
            pgscore: +this.pg.projectpgstotalrule===1 ? 100 : this.pg.pricescore,
            pgisend: 1,
            pglevel: 1
          },{
            pgid: this.list.length ? this.list[1].pgid : '',
            pgprojectid: this.projectid,
            pgparentid: 0,
            pgseq: 2,
            pgname: '评审',
            pgflg: 2,
            pgratio: this.pg.commercescore,
            pgisend: 0,
            pglevel: 1
          }]
          if (+this.project.projectdoneflg === 5) {
            list.push({
              pgid: this.list.length ? this.list[2].pgid : '',
              pgprojectid: this.projectid,
              pgparentid: 0,
              pgseq: 3,
              pgname: '履约',
              pgflg: 3,
              pgisend: 1,
              pglevel: 1,
              pgscore: this.project.projectperformancescore,
              pgratio: this.project.projectperformancescore,
            })
          }
          this.btnLoading = false;
          let res = await request({
            url: '/xmgl/pg/savePgList',
            method: "post",
            data: {
              projectid: this.projectid,
              projectpgstotalrule: this.pg.projectpgstotalrule,
              list: list
            }
          })
          if (res.issuccess === -1) {
            this.$message.warning(res.msg)
          } else {
            this.$message.success('保存成功')
            await this.getPgParentList()
          }
        })
      },
      async getPgParentList () {
        await this.getModel()
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/pg/getPgParentList',
          params: {projectid: this.projectid}
        })
        this.list = res
        if (this.list.length) {
          this.pg.projectpgstotalrule = this.project.projectpgstotalrule.toString()
          this.pg.pricescore = this.list[0].pgratio.toString()
          this.pg.commercescore = this.list[1].pgratio.toString()
          // this.pg.pgstechnologyscore = this.list[2].pgratio.toString()
        } else {
          this.pg = {
            projectpgstotalrule:2,
            pricescore: '',
            commercescore: ''
          }
        }

      },
      async checkScore () {
        this.alertmsg = ''
        let res = await request({
          method: 'get',
          url: '/xmgl/pg/getPgList',
          params: {projectid: this.projectid}
        })
        console.log(res.list.length)
        if (res.list.length) {
          let ratioTotal = res.list.length ? res.list.map(t => Number(t.pgratio)).reduce((a, b) => a + b) : 0
          if (ratioTotal !== 100) {
            if (+this.project.projectpgstotalrule === 1) {
              this.alertmsg = '当前项目总分计算方式为"百分比"，权重合计必须等于100！'
            } else {
              this.alertmsg = '当前项目总分计算方式为"绝对值"，分值合计必须等于100分！'
            }
          }
          if (this.alertmsg) {
            this.$message.warning(this.alertmsg)
            return
          }
          this.$message.success('分值检查通过！')
        } else {
          let sum = Number(this.pg.pricescore) + Number(this.pg.commercescore)
          if (+this.project.projectdoneflg === 5) {
            sum += Number(this.project.projectperformancescore)
          }
          if(sum != 100){
            this.$message.warning('总分应该等于100！')
            return
          } 
          this.$message.success('分值检查通过！')
        }
      }
    },
    computed: {
      alreadyTotal () {
        return Number(this.pg.pricescore) + Number(this.pg.commercescore)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea {
      width: 520px;
    }
  }
</style>
